<template>
  <div class="colors-tab">
    <v-data-table
      :headers="headers"
      :items="colors"
      hide-default-footer
      fixed-header
      height="500"
      :items-per-page="-1"
      class="mb-6"
    >
      <template #top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Couleurs</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template #activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nouveau</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-validate="'required'"
                        data-vv-name="label"
                        :error="errors.has('label')"
                        v-model="editedItem.label"
                        label="Libellé"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="editedItem.type"
                        :items="typeItems"
                        label="Type"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="editedItem.texture"
                        :items="textureItems"
                        label="Texture"
                        @change="resetTextures"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" v-if="editedItem.texture == 'COLOR'">
                      <v-text-field
                        v-model="editedItem.rgb_code"
                        label="Code couleur"
                      ></v-text-field>
                    </v-col>
                    <v-row v-if="editedItem.texture == 'TEXTURE'">
                      <v-col cols="8">
                        <!-- Image -->
                        <v-file-input
                          label="Image"
                          @change="onFileChange"
                          @click:clear="editedItem.previewImage = null"
                        ></v-file-input>
                      </v-col>
                      <v-col cols="4">
                        <img
                          v-if="editedItem.previewImage"
                          :src="editedItem.previewImage"
                          style="width: 100%; height: 100%"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="save"
                  >Enregistrer</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- Soft delete -->
      <template #item.idc_soft_delete="{ value }">
        <v-checkbox :value="value" readonly disabled></v-checkbox>
      </template>

      <!-- Actions -->
      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import ColorsRepo from "@/repositories/settings/colors";

  export default {
    name: "ColorsTab",
    data() {
      return {
        headers: [
          {
            text: "Couleur",
            align: "left",
            value: "label"
          },

          {
            text: "Catégorie",
            align: "left",
            value: "type"
          },

          {
            text: "Actions",
            value: "action",
            sortable: false
          }
        ],

        colors: [],

        textureItems: [
          { text: "Couleur", value: "COLOR" },
          { text: "Texture", value: "TEXTURE" }
        ],

        typeItems: [
          "SEAT",
          "THERMO",
          "STRETCH",
          "PLASTAZOTE",
          "XXL",
          "LIGHT",
          "PALMA",
          "EVAZOTE",
          "SKAI",
          "ALCANTARA",
          "3D",
          "BASES",
          "LIFT",
          "TRANSFER",
          "STRAP"
        ],

        defaultItem: {
          label: null,
          type: null,
          image: null,
          texture: "COLOR",
          rgb_code: null
        },

        dialog: false,
        editedId: -1,
        editedItem: {
          label: null,
          type: null,
          image: null,
          texture: "COLOR",
          rgb_code: null,
          previewImage: null
        },

        confirmationDialog: false
      };
    },
    computed: {
      formTitle() {
        return this.editedId === -1
          ? "Ajouter une couleur"
          : "Modifier une couleur";
      }
    },
    methods: {
      onFileChange(file) {
        this.editedItem.image = file;
        this.editedItem.previewImage = URL.createObjectURL(file);
      },

      resetTextures() {
        this.editedItem.rgb_code = null;
        this.editedItem.image = null;
        this.editedItem.previewImage = null;
      },

      editItem(item) {
        this.editedId = item.id;
        this.editedItem = Object.assign({}, item);

        if (item.image) {
          this.editedItem.previewImage = item.image;
        }

        this.dialog = true;
      },

      /**
       * Delete a color
       */
      async deleteItem(item) {
        confirm("Voulez-vous vraiment supprimer cette couleur?") &&
          (await ColorsRepo.deleteColor(item.id));

        this.getColors();
      },

      /**
       * Save manpower on server
       */
      async save() {
        // Check if form is valid
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          return;
        }

        let formData = new FormData();

        if (this.editedItem.image && this.editedItem.image instanceof File ) {
          formData.append("image", this.editedItem.image);
        }

        formData.append("label", this.editedItem.label);
        formData.append("type", this.editedItem.type);
        formData.append("texture", this.editedItem.texture);
        formData.append("rgb_code", this.editedItem.rgb_code);

        if (this.editedId > -1) {
          await ColorsRepo.updateColor(this.editedId, formData);
        } else {
          await ColorsRepo.create(formData);
        }

        this.getColors();
        this.close();
      },

      /**
       * Close dialog and reset edited item
       */
      close() {
        this.dialog = false;
        this.errors.clear();
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedId = -1;
        }, 300);
      },

      /**
       * Get all colors
       */
      async getColors() {
        try {
          const { data } = await ColorsRepo.get();
          this.colors = data;
        } catch (error) {
          alert(error);
        }
      }
    },
    created() {
      this.getColors();
    }
  };
</script>

<style lang="scss">
  .colors-tab {
    .v-data-table__wrapper {
      height: 470px !important;
    }
    .total {
      p {
        text-align: right;
        color: #006064;
        font-weight: bold;
        font-size: 15px !important;
      }
    }
    .v-data-table table tr td {
      height: auto !important;
    }
    .v-data-table table tbody td .v-input .v-input__control .v-input__slot {
      height: auto !important;
    }
  }
</style>
